;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type {
	TourStep,
	TourStepData,
} from "@/features/onboarding-tours/types/tour-definition";

const DEFAULT_TOUR_STEP_DATA: TourStepData = {
	advanceOn: "none",
	showControls: true,
	showSkip: true,
};

export function tourStep({
	data,
	...step
}: Omit<TourStep, "data"> & { data?: Partial<TourStepData> }): TourStep {
	return {
		blockTargetInteraction: false,
		data: { ...DEFAULT_TOUR_STEP_DATA, ...data },
		skipBeacon: true,
		skipScroll: true,
		spotlightPadding: 10,
		...step,
	};
}
